import req from './../../../fetch';
import { paramsToString, undocumentedResponse } from './../../../utils';
import {
  AllAPIResponses,
  AlarmNoteResponseType,
  CarbonError,
} from './../../../index';

type Params = {
  alarmTs: string;
  nodeId: number;
  ruleid: number;
};
const get = async (
  params: Params,
  headers?: Headers
): Promise<AllAPIResponses<AlarmNoteResponseType>> => {
  try {
    const resp = await req.get(
      `/api/alarms/notes${paramsToString(params)}`,
      headers
    );
    const clone = resp.clone();
    switch (resp.status) {
      case 200:
        return {
          data: (await resp.json()) as AlarmNoteResponseType,
          response: clone,
        };
      case 400:
      case 401:
      case 403:
      case 404:
      case 500:
        return {
          error: (await resp.json()) as CarbonError,
          response: clone,
        };
      default:
        return {
          error: new Error(undocumentedResponse(resp)),
          response: clone,
        };
    }
  } catch (e) {
    return { error: e, response: undefined };
  }
};

export default get;
